import React, { FC } from "react";
import { DATE_FORMAT, TCalendarMeetingsColor, getDateWithCorrectTime, setClass } from "../../utils";
import { MeetingRound } from "./MeetingRound";
import { observer } from "mobx-react-lite";
import { format, getMonth } from "date-fns";
import '../../styles/components/miniCalendarDay.scss';

interface MiniCalendarDayProps {
  filteredMeetings: TCalendarMeetingsColor;
  date: Date;
  startDate: Date;
  today: Date;
  selectedDate: Date;
  onClick: (day: Date) => void;
}

export const MiniCalendarDay: FC<MiniCalendarDayProps> = observer(({ 
  filteredMeetings, date, today, startDate, selectedDate, onClick: setDate 
}) => {
  const day = getDateWithCorrectTime(date, startDate.getHours(), startDate.getMinutes());
  const meetings = filteredMeetings.get(day.toDateString())?.slice(0,6);
  
  const getClassName = (item: Date) => {
    const currentMonthClassName = getMonth(startDate) === getMonth(item) && 'current-month';
    const todayClassName = format(today, DATE_FORMAT) === format(item, DATE_FORMAT) && 'today';
    const selected = selectedDate && format(selectedDate, DATE_FORMAT) === format(item, DATE_FORMAT) && 'selected';
    return setClass('day', 'clickable', currentMonthClassName, todayClassName, selected);
  };

  const onClick = () => setDate(day);

  return (
    <div>
      <span
        className={getClassName(day)}
        onClick={onClick}
      >
        {day.getDate()}
      </span>
      <div className="round-meeting-list">
        {meetings?.map((meeting) => (
          <MeetingRound key={meeting} color={meeting}/>
        ))}
      </div>
    </div>
  )
})
